import Application from './application';

if (__DEV__) {
  console.log('DEVELOPMENT ENVIRONMENT');
}
if (__SRC__) {
  console.log('SOURCE ENVIRONMENT');
}
if (__DIST__) {
  console.log('DISTRIBUTION ENVIRONMENT');
}

window.ironSelector = new Application();
// window.intro = new Intro({});
// window.preloader = new Preloader({test: 'hello'});
// window.question1 = new Question({elementId: 'question-1'});

// /**
//  * IFRAME RESIZING
//  */
// function resizeFrame() {
//   //TODO: debounce this?
//   let height = 0;
//   // dont resize dynamically during intro
//   // if ( document.getElementById('intro').style.display === "none" ) {
//     // var height = document.getElementsByTagName("html")[0].scrollHeight;
//     height = document.getElementById('main').scrollHeight;
//   // } else {
//   //   height = 0;
//   // }
//   // console.log('resizeFrame ' + height);
//
//   if ( height >= 0 ) {
//     window.parent.postMessage([height], "*");
//   }
// }
// window.addEventListener('load', resizeFrame);
// window.addEventListener('resize', resizeFrame);

